/* tslint:disable */
/* eslint-disable */
import { graphql } from './__generated__';

export const calculateResult = graphql(`
    query CalculateResult($input: FormData!) {
        calculateResult(input: $input) {
            totalPercentage
            answers {
                wellbeingA {
                    section
                    question
                    answer
                    answerText
                }
                worklifeA {
                    section
                    question
                    answer
                    answerText
                }
                wealthA {
                    section
                    question
                    answer
                    answerText
                }
            }
            score {
                wellbeingScore
                worklifeScore
                wealthScore
                overallMessage
            }
            overallSectionParagraphs {
                wellbeingParagraph
                worklifeParagraph
                wealthParagraph
            }
            topTips {
                section
                text
                link_1
                link_1_url
                link_2
                link_2_url
                link_3
                link_3_url
                link_4
                link_4_url
                link_5
                link_5_url
                link_6
                link_6_url
            }
            allSectionTips {
                wellbeingTips {
                    section
                    text
                    link_1
                    link_1_url
                    link_2
                    link_2_url
                    link_3
                    link_3_url
                    link_4
                    link_4_url
                    link_5
                    link_5_url
                    link_6
                    link_6_url
                }
                worklifeTips {
                    section
                    text
                    link_1
                    link_1_url
                    link_2
                    link_2_url
                    link_3
                    link_3_url
                    link_4
                    link_4_url
                    link_5
                    link_5_url
                    link_6
                    link_6_url
                }
                wealthTips {
                    section
                    text
                    link_1
                    link_1_url
                    link_2
                    link_2_url
                    link_3
                    link_3_url
                    link_4
                    link_4_url
                    link_5
                    link_5_url
                    link_6
                    link_6_url
                }
            }
        }
    }
`);

export const createSession = graphql(`
    query CreateSession {
        createSession
    }
`);

export const updateSessionEvent = graphql(`
    query UpdateSessionEvent($input: SessionEventInput) {
        updateSessionEvent(input: $input)
    }
`);

export const updateSessionResult = graphql(`
    query UpdateSessionResult($input: SessionResultInput) {
        updateSessionResult(input: $input)
    }
`);

export const submitFeedback = graphql(`
    query SubmitFeedback($input: FeedbackInput) {
        submitFeedback(input: $input)
    }
`);
